import { render, staticRenderFns } from "./NewsCoverUpload.vue?vue&type=template&id=9b2652ce&scoped=true"
import script from "./NewsCoverUpload.vue?vue&type=script&lang=js"
export * from "./NewsCoverUpload.vue?vue&type=script&lang=js"
import style0 from "./NewsCoverUpload.vue?vue&type=style&index=0&id=9b2652ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2652ce",
  null
  
)

export default component.exports